import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import { buildErrorMessageForName } from "@gettactic/helpers/src/hook-form/buildErrorMessageForName";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { ResourcePickerFieldInput } from "./ResourcePickerFieldInput";
import { HookFormResourcePickerFieldInputProps } from "./ResourcePickerFieldInput.types";

export const HookFormResourcePickerFieldInput = <T extends FieldValues>(
  props: HookFormResourcePickerFieldInputProps<T>
): React.ReactElement => {
  const {
    form,
    name,
    rules,
    getSelectedLabel,
    clearValue = "",
    label,
    isRequired,
    description,
    icon,
    placeholder,
    onOpen,
    disabled,
    clearLabel
  } = props;

  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({ form, name, rules, isRequired })}
      render={({ field, fieldState }) => {
        const selectedLabel = getSelectedLabel(field.value);
        return (
          <ResourcePickerFieldInput
            label={label}
            isRequired={isRequired}
            description={description}
            icon={icon}
            placeholder={placeholder}
            onOpen={onOpen}
            disabled={disabled}
            clearLabel={clearLabel}
            isSelected={selectedLabel !== null}
            selectedLabel={selectedLabel ?? undefined}
            onClear={() => field.onChange(clearValue)}
            error={
              fieldState.error?.message ||
              buildErrorMessageForName(form, name) ||
              undefined
            }
          />
        );
      }}
    />
  );
};
